import axios from 'axios';

export const adminApi = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use((response) => response, (error) => {
  if (error.response?.status === 401) {
    localStorage.removeItem('admin_token');
    if (!error.config?.silentAuthFailure) {
      window.dispatchEvent(new Event('admin-session-expired'));
    }
  }
  return Promise.reject(error);
});

export const formatApiError = (error, fallback) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg || '').filter(Boolean).join(' ') || fallback;
  return fallback;
};